export interface AuthenticationToken {
    keychainId: string;
    description: string;
    username: string;
    stage: RegistrationStage;
}

export enum RegistrationStage {
    CREATED = 'created',
    VERIFY_TOKEN = 'verify_token',
    VERIFY_PERSON = 'verify_person',
    VERIFIED = 'verified'
}
